import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import TextArea from '@/common/components/TextArea'
import { useSendEstablishmentLeadEquipment } from '@/features/establishmentLeadsFunnel/hooks/useSendEstablishmentLeadEquipment'
import { sendEstablishmentLeadEquipmentSchema, SendEstablishmentLeadEquipmentValidationSchema } from '@/features/establishmentLeadsFunnel/schemas/update.schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

export const SendEquipmentModal = ({ establishmentLeadId }: { establishmentLeadId?: string }) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { errors }
  } = useForm<SendEstablishmentLeadEquipmentValidationSchema>({
    resolver: zodResolver(sendEstablishmentLeadEquipmentSchema)
  })

  const onSubmit: SubmitHandler<SendEstablishmentLeadEquipmentValidationSchema> = (data) => {
    sendEstablishmentLeadEquipment(data)
  }

  const onSuccess = () => {
    resetForm()
    queryClient.invalidateQueries({ queryKey: ['establishmentLead', establishmentLeadId] })
    setIsOpen(false)
  }

  const {
    mutate: sendEstablishmentLeadEquipment,
    isPending: sendEstablishmentLeadEquipmentIsPending,
    isError: sendEstablishmentLeadEquipmentIsError,
  } = useSendEstablishmentLeadEquipment({
    establishmentLeadId,
    onSuccess,
  })

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
      Trigger={
        <Button type="button" variant="success" className='w-full'>
          Marcar envio
        </Button>
      }
      showClose={false}
      title="Envio de equipamentos e kits promocionais"
      footer="Enviar para o contato"
      confirmButtonIsLoading={sendEstablishmentLeadEquipmentIsPending}
      body={(
        <form className="flex flex-col gap-y-4">
          {sendEstablishmentLeadEquipmentIsError && (
            <p className="text-sm text-danger-soft">
              Ocorreu um erro no servidor, cheque os campos e tente novamente
            </p>
          )}

          <TextArea
            label="Mensagem para o contato"
            maxLength={256}
            errorMessage={errors?.message?.message}
            {...register('message')}
            disabled={sendEstablishmentLeadEquipmentIsPending}
          />
        </form>
      )}
    />
  )
}
